export enum ELocale {
  VI = 'vi',
  EN = 'en',
}
